module.exports = "<mat-radio-group class=\"frames\" [(ngModel)]=\"selectedFrame\" (change)=\"frameChanged($event)\">\n  <mat-radio-button class=\"frame\" *ngFor=\"let frame of frames\" [value]=\"frame.id\">\n    {{ getFrameName(frame) }} <span class=\"price\">{{ getFramePrice(frame) }}</span>\n  </mat-radio-button>\n</mat-radio-group>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/map-config-frame/map-config-frame.component.html
// module id = ../../../../../src/app/components/map-config-frame/map-config-frame.component.html
// module chunks = main